import React from 'react';
import DashboardLayout from '../../components/dashboard/DashboardLayout';

const InterviewManagerStyleGuide = () => {
    return (
        <DashboardLayout>
            <h1>Interview Manager Style Guide</h1>
        </DashboardLayout>
    );
};

export default InterviewManagerStyleGuide;  